module.exports = __webpack_public_path__ + "img/logo-es.d7d186fd.png";